export default {
      id: "refresh-usage",
      viewBox: "0 0 24 20",
      url: __webpack_public_path__ + "sprite.svg#refresh",
      toString: function () {
        return this.url;
      }
    }